<template>
  <div class="root-container">
    <!--图表-->
    <el-row class="box-header">
      <el-col class="chart-title-text-container" :span="12">
        <div class="chart-title-text">{{title}}</div>
        <el-tooltip effect="dark" placement="right">
          <i class="icon-question-circle"></i>
          <div slot="content">
            活跃周期：设备首次上线到最后一次上线的时间跨度。<br/>各个活跃周期数据不重叠，比如：“一周以上”表示“一周以上，一个月以下”，以此类推。
          </div>
        </el-tooltip>
      </el-col>
      <el-col class="chart-subtitle-text-container" :span="12">
        <div class="chart-subtitle-text">
          截止{{endAt}}
        </div>

        <el-date-picker
          v-model="endAt"
          type="date"
          range-separator="至"
          size="mini"
          :editable="false"
          :clearable="true"
          format="yyyy/M/d"
          value-format="yyyy/M/d"
          placeholder="选择截止日期"
          @change="changeEndAt"
          :picker-options="pickerOptions"
          style="width:140px;margin-left: 10px;">
        </el-date-picker>

      </el-col>
    </el-row>
    <el-row class="box-main" style="height: 400px">
      <div v-loading="loading" element-loading-spinner="el-icon-loading" class="box-chart" ref="chart_ref"/>
    </el-row>
    <!--列表-->
    <el-row class="box-header" style="margin-top: 30px">
      <el-col class="chart-title-text-container" :span="12">
        <div class="chart-title-text">活跃周期分布明细</div>
      </el-col>
      <el-col class="chart-subtitle-text-container" :span="12">
        <div class="chart-subtitle-text">
          截止{{endAt}}
        </div>
      </el-col>
    </el-row>
    <el-row class="box-main" style="height: 400px;">
      <el-table :data="detail" max-height="400" v-loading="loading" element-loading-spinner="el-icon-loading">
        <el-table-column label="#" width="50" align="center">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="active_period" label="活跃周期" align="center"/>
        <el-table-column prop="device_count" label="设备数" align="center"/>
        <el-table-column prop="device_percent" label="设备占比" align="center"/>
      </el-table>
    </el-row>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import {GetActivePeriodInfo} from "../api/api";

  export default {
    data() {
      return {
        token: '',
        title: '不同活跃周期的设备占比',
        detail: [],
        xdata: ['一周以下', '一周以上', '一个月以上', '三个月以上', '半年以上', '一年以上'],
        ydata: [],
        endAt: '',
        pickerOptions: {
          disabledDate(time) {
            // 最晚到昨天
            let now = new Date()
            let todayZero = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
            return time.getTime() >= todayZero.getTime();
          },
          shortcuts: [{
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近90天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        mChart: null,
        mOption: null,
        loading:false
      }
    },
    methods: {
      query() {
        this.loading = true

        var that = this
        var params = {
          token: this.token,
        }
        if (this.endAt) {
          params['end_at'] = this.endAt
        }
        console.log('params', params)
        GetActivePeriodInfo(params).then(res => {
          var total = 0;
          for (var index in res.data.active_cycle) {
            total += parseInt(res.data.active_cycle[index].device_count);
          }

          that.ydata.splice(0, that.ydata.length)

          that.detail = res.data.active_cycle;
          for (var index in res.data.active_cycle) {
            that.ydata.push(parseFloat(res.data.active_cycle[index].device_count / total * 100).toFixed(1));
            that.detail[index].active_period = that.xdata[index];
            that.detail[index].device_count = res.data.active_cycle[index].device_count;
            that.detail[index].device_percent = that.ydata[index] + '%';
          }

          this.mChart.setOption(this.mOption);

          this.loading = false

          console.log('GetActivePeriodInfo', res,total,that.ydata)
        }).catch(err => {
          console.log('GetActivePeriodInfo-err', err)

          this.loading = false
        });
      },
      initEndAt() {
        var end = new Date()
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
        this.endAt = end.toLocaleDateString()
      },
      changeEndAt(value) {
        console.log('changeEndAt', value)
        this.$nextTick(() => {
          if (!value) {
            this.initEndAt()
          }
          this.query()
        })
      }
    },
    created() {
      this.token = sessionStorage.getItem("BBRtoken");
      this.initEndAt()
    },
    mounted() {
      var that = this;
      // 初始化图表
      this.mChart = echarts.init(this.$refs.chart_ref);
      this.mOption = {
        color: ['rgb(126,182,234)'],
        tooltip: {
          trigger: 'axis',
          formatter: "[{b}]设备占比<br/>- {c}%"
        },
        grid: {
          top: '10%',
          left: '3%',
          right: '3%',
          bottom: '10%',
          containLabel: true
        },
        // legend: {
        //     // data: ['12'],
        //     // left: 'auto',
        //     // type: 'plain',
        //     show: true
        // },
        xAxis: {
          data: that.xdata,
          axisLine: {
            lineStyle: {
              color: '#d2e2e2'
            }
          },
          axisLabel: {
            color: '#8492A6',
            fontWeight: 'bold'
          }
        },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#e2e2e2'],
              type: 'dotted'
            }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#8492A6',
            fontWeight: 'bold',
            formatter: '{value}%'
          }
        },
        series: {
          name: that.title,
          type: 'bar',
          barWidth: '50%',
          data: that.ydata,
        }
      };
      // 请求数据
      this.query()
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// AnalyzeActivePeriodManagement.vue?04c9f743